import { SVGProps } from 'react';

function Eye(props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={22}
      height={20}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M11 4.376c-3.36-.057-6.833 2.29-9.017 4.695a1.386 1.386 0 0 0 0 1.855c2.136 2.353 5.6 4.755 9.017 4.697 3.417.058 6.882-2.344 9.02-4.697a1.386 1.386 0 0 0 0-1.855C17.833 6.667 14.36 4.319 11 4.376Z"
        stroke="#7B829D"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        clipRule="evenodd"
        d="M14.125 10a3.125 3.125 0 1 1-6.25-.002 3.125 3.125 0 0 1 6.25.002v0Z"
        stroke="#7B829D"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

Eye.defaultProps = {
  role: 'graphics-document',
};

export default Eye;
